import React from 'react';
import { Helmet } from 'react-helmet-async';

const PrivacyPage: React.FC = () => (
  <>
    <Helmet>
      <title>Privacy Policy | VB Entreprise | Premium IT & Digital Marketing Agency for US, UK & Canada Businesses</title>
    </Helmet>
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
      <p className="text-gray-700 mb-6">
        This Privacy Policy explains how <strong>VB Unified Entreprise OPC Private Limited</strong> ("we", "us", or "our") collects, uses, and protects your information when you use our website and services.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">1. Information We Collect</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>Personal information (name, email, phone, etc.) you provide via forms or contact.</li>
        <li>Usage data (pages visited, browser type, device info, etc.).</li>
        <li>Cookies and similar tracking technologies.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>To provide and improve our services.</li>
        <li>To respond to your inquiries and requests.</li>
        <li>To send updates, offers, and marketing communications (you can opt out at any time).</li>
        <li>To analyze website usage and enhance user experience.</li>
        <li>To comply with legal obligations.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">3. Data Sharing & Security</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>We do not sell your personal information.</li>
        <li>We may share data with trusted partners for service delivery (e.g., payment processors, analytics).</li>
        <li>We implement industry-standard security measures to protect your data.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">4. Your Rights</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>You can request access, correction, or deletion of your personal data.</li>
        <li>You can opt out of marketing communications at any time.</li>
        <li>Contact us for any privacy-related requests or questions.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">5. Changes to This Policy</h2>
      <p className="text-gray-700 mb-4">
        We may update this Privacy Policy from time to time. The latest version will always be posted on this page.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">6. Contact</h2>
      <p className="text-gray-700">
        For questions or requests regarding your privacy, please contact us at <a href="mailto:contact@vb-entreprise.com" className="text-jordy-blue-600 underline">contact@vb-entreprise.com</a>.<br/>
        <span className="block mt-2">VB Unified Entreprise OPC Private Limited</span>
      </p>
    </div>
  </>
);

export default PrivacyPage; 